import { css } from '@emotion/react'
import { mobile } from '../../../../style_helpers/emotion_media_queries'

const base = css`
  font-size: 54px;
`

const mobileStyles = css`
  ${mobile} {
    font-size: 40px;
  }
`

export default {
  base,
  mobile: mobileStyles
}
